import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
} from "ui/store";
import SummaryControlsAccordion from "./summary-controls-accordion";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    Summary_StartDate: getResource(state, { key: "Summary_StartDate" }),
    Summary_Header: getResource(state, { key: "Summary_Header" }),
    Summary_Lead_Link: getResource(state, { key: "Summary_Lead_Link" }),
    Summary_Lead_Part1: getResource(state, { key: "Summary_Lead_Part1" }),
    Summary_Lead_Bold: getResource(state, { key: "Summary_Lead_Bold" }),
    Summary_Lead_Part2: getResource(state, { key: "Summary_Lead_Part2" }),
    Summary_TotalPrice: getResource(state, { key: "Summary_TotalPrice" }),
    Summary_TaxAndShipping: getResource(state, {
        key: "Summary_TaxAndShipping",
    }),
    Product_Price_Format: getResource(state, {
        key: "Product_Price_Format",
    }),
    calendar: getCalendar(state),
    activeComponent: getActiveNavigationComponent(state),
});
const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SummaryControlsAccordion);
